import React from 'react';
import { Link } from 'react-router-dom';

interface PillarClusterNavProps {
  servicePages: Array<{ href: string; label: string }>;
  clusterBlogs: Array<{ slug: string; title: string }>;
}

const PillarClusterNav: React.FC<PillarClusterNavProps> = ({ servicePages, clusterBlogs }) => {
  return (
    <section className="py-12 bg-white">
      <div className="container-custom max-w-5xl">
        <h2 className="text-2xl sm:text-3xl font-heading font-bold text-gray-900 mb-8">
          Conditions I Help With
        </h2>
        <div className="grid md:grid-cols-3 gap-4 mb-8">
          {servicePages.map((sp) => (
            <Link
              key={sp.href}
              to={sp.href}
              className="border border-gray-200 rounded-xl p-5 hover:border-accent-300 hover:shadow-sm transition-all"
            >
              <span className="text-accent-600 font-semibold">{sp.label}</span>
            </Link>
          ))}
        </div>
        {clusterBlogs.length > 0 && (
          <>
            <h3 className="text-xl font-heading font-semibold text-gray-900 mb-4 mt-8">
              Related Articles
            </h3>
            <ul className="space-y-3">
              {clusterBlogs.map((blog) => (
                <li key={blog.slug}>
                  <Link
                    to={'/blog/' + blog.slug}
                    className="text-accent-600 hover:text-accent-700 underline underline-offset-2"
                  >
                    {blog.title}
                  </Link>
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
    </section>
  );
};

export default PillarClusterNav;
